document.addEventListener('DOMContentLoaded', () => {
    // Step 1: Parse product JSON
    const productJsonElement = document.querySelector('#price-per-item');
    if (!productJsonElement) return;
    const productJson = JSON.parse(productJsonElement.getAttribute('data-product_json'));
    if (!productJson || !productJson.variants) return;
  
    // Debug: check parsed JSON
    console.log('Product JSON loaded:', productJson);
  
    // Step 2: Function to update price per item
    function updatePricePerItem() {
      const selectedRadio = document.querySelector('input[name="Quantity-2"]:checked');
      if (!selectedRadio) return;
  
      const radioValue = selectedRadio.value;
      // Extract pack number from radio button, e.g., "Pack of 25" → 25
      const match = radioValue.match(/\d+/);
      if (!match) return;
  
      const packSize = parseInt(match[0], 10);
      console.log('Selected pack size:', packSize);
  
      // Step 3: Extract the selected color from the radio button's name or other related attributes
      // Example: We'll check if the color is part of the name or options for matching
      const selectedColorRadio = document.querySelector('input[name="Quantity-2"]:checked + label');
      const selectedColor = selectedColorRadio ? selectedColorRadio.innerText.toLowerCase() : '';
      console.log('Selected color:', selectedColor);
  
      // Step 4: Find the selected variant based on both color and pack size
      const selectedVariant = productJson.variants.find(variant => {
        const variantTitle = variant.title.toLowerCase();
        // Check if the variant title contains both color and pack size
        return variantTitle.includes(selectedColor) && variantTitle.includes(`pack of ${packSize}`);
      });
  
      console.log('Matched variant:', selectedVariant);
  
      // Step 5: If a valid variant is selected, calculate the price per item
      const priceElement = document.getElementById('per-item-price');
      if (selectedVariant && priceElement) {
        const totalPrice = selectedVariant.price / 100; // Shopify prices are in cents
        const pricePerItem = (totalPrice / packSize).toFixed(2);
        priceElement.innerText = pricePerItem;
      } else if (priceElement) {
        priceElement.innerText = 'N/A';
      }
    }
  
    // Step 6: Attach event listeners to all quantity radio buttons
    const radios = document.querySelectorAll('input[name="Quantity-2"]');
    radios.forEach(radio => {
      radio.addEventListener('change', updatePricePerItem);
    });
  
    // Step 7: Initialize price per item on page load
    updatePricePerItem();
  });
  
  (function () {
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      // Check if the link is not to the same hostname
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
  
      // Check if the link is a PDF
      if (links[i].href.toLowerCase().endsWith('.pdf')) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  })();
  
////////////////////////////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function() {
  // Get the variant select element (radio buttons for this specific product)
  const variantRadios = document.querySelectorAll('.product-form__input input[type="radio"]');

  // Get all the thumbnail images
  const thumbnailImages = document.querySelectorAll('.thumbnail-list__item img');
  
  // Get the product title text
  const productTitle = document.querySelector('.product__title h1')?.innerText.trim().toLowerCase();
  
  // Collect all available variant names for comparison
  const allVariantNames = Array.from(variantRadios).map(radio => 
    radio.value.trim().toLowerCase()
  );
  
  // Function to check if alt text is generic (doesn't match any variant)
  function isGenericAltText(altText) {
    // Empty alt text is considered generic
    if (!altText) return true;
    
    // Check if alt text matches the product title
    if (productTitle && altText === productTitle) return true;
    
    // Check if alt text matches any variant name
    const matchesAnyVariant = allVariantNames.some(variantName => 
      altText === variantName
    );
    
    // If it doesn't match any variant, it's generic
    return !matchesAnyVariant;
  }
  
  // Function to update thumbnails based on selected variant
  function updateThumbnails() {
    const selectedVariant = document.querySelector('.product-form__input input[type="radio"]:checked')?.value;
    const variantName = selectedVariant ? selectedVariant.trim().toLowerCase() : null;

    // Loop through all thumbnails and show/hide based on alt text matching the selected variant
    thumbnailImages.forEach(function(thumbnail) {
      const altText = thumbnail.alt.trim().toLowerCase();
      const container = thumbnail.closest('.thumbnail-list__item');
      
      let shouldShow = false;

      // Case 1: Image has no alt text (empty or null alt) - Show for all variants
      if (!altText) {
        shouldShow = true;
      }
      // Case 2: Image alt text matches the product title - Show for all variants
      else if (productTitle && altText === productTitle) {
        shouldShow = true;
      }
      // Case 3: Image alt text is generic (doesn't match any variant name) - Show for all variants
      else if (isGenericAltText(altText)) {
        shouldShow = true;
      }
      // Case 4: Image alt text matches the selected variant - Show only for the selected variant
      else if (variantName && altText === variantName) {
        shouldShow = true;
      }
      // Case 5: Image alt text matches a different variant - Hide for the selected variant
      else if (variantName && allVariantNames.includes(altText) && altText !== variantName) {
        shouldShow = false;
      }
      // Case 6: No variant selected yet - Show all images
      else if (!variantName) {
        shouldShow = true;
      }
      // Fallback: Show by default (safety net)
      else {
        shouldShow = true;
      }

      // Apply the display style
      if (container) {
        container.style.display = shouldShow ? 'block' : 'none';
      }
    });
  }

  // Call the function once when the page loads
  updateThumbnails();

  // Add event listeners to update thumbnails when the variant is changed
  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', updateThumbnails);
  });

  // Listen for changes in the URL (popstate and pushState)
  function onUrlChange() {
    updateThumbnails();
  }

  // Event listener for when the browser history changes
  window.addEventListener('popstate', onUrlChange);

  // Listen for changes triggered by `pushState` or `replaceState`
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function(state, title, url) {
    originalPushState.apply(history, arguments);
    onUrlChange();
  };

  history.replaceState = function(state, title, url) {
    originalReplaceState.apply(history, arguments);
    onUrlChange();
  };

  // Optionally, you can also listen for the hashchange event if URL changes involve hash
  window.addEventListener('hashchange', onUrlChange);
});

/****************** Header dropdown JS Start *************/

// $(function() {
//   $('header .header__inline-menu details').on('mouseover', function() {
//     $(this).attr('open', true);
//   }).on('mouseout', function() {
//     $(this).attr('open', false);
//   })
// });
/****************** Header dropdown JS End *************/
